/**
 * Utility to convert numbers to Arabic words (Tafqit) specifically for Kuwaiti Dinar.
 * Example: 600 -> ستمئة دينار كويتي فقط لا غير
 */

const ones = ["", "واحد", "اثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة", "عشرة"];
const teens = ["عشرة", "إحدى عشر", "اثنا عشر", "ثلاثة عشر", "أربعة عشر", "خمسة عشر", "ستة عشر", "سبعة عشر", "ثمانية عشر", "تسعة عشر"];
const tens = ["", "عشرة", "عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"];
const hundreds = ["", "مئة", "مئتان", "ثلاثمئة", "أربعمئة", "خمسمئة", "ستمئة", "سبعمئة", "ثمانمئة", "تسعمئة"];

export function numberToArabicWords(n: number): string {
    if (n === 0) return "صفر";
    
    // Split into Dinar and Fils
    const dinars = Math.floor(n);
    const fils = Math.round((n - dinars) * 1000);

    let result = "";

    if (dinars > 0) {
        result += convertGroup(dinars);
        if (dinars >= 3 && dinars <= 10) {
            result += " دنانير";
        } else {
            result += " ديناراً";
        }
    }

    if (fils > 0) {
        if (dinars > 0) result += " و ";
        result += convertGroup(fils) + " فلس";
    }

    return result.trim() + " كويتي فقط لا غير";
}

function convertGroup(n: number): string {
    if (n === 0) return "";
    
    let parts: string[] = [];

    // Thousands
    if (n >= 1000) {
        const thousand = Math.floor(n / 1000);
        if (thousand === 1) parts.push("ألف");
        else if (thousand === 2) parts.push("ألفين");
        else if (thousand >= 3 && thousand <= 10) parts.push(ones[thousand] + " آلاف");
        else parts.push(convertGroup(thousand) + " ألف");
        n %= 1000;
    }

    // Hundreds
    if (n >= 100) {
        parts.push(hundreds[Math.floor(n / 100)]);
        n %= 100;
    }

    // Tens and Ones
    if (n > 0) {
        if (n < 11) {
            parts.push(ones[n]);
        } else if (n < 20) {
            parts.push(teens[n - 10]);
        } else {
            const one = n % 10;
            const ten = Math.floor(n / 10);
            if (one > 0) {
                parts.push(ones[one] + " و " + tens[ten]);
            } else {
                parts.push(tens[ten]);
            }
        }
    }

    return parts.join(" و ");
}
